import React from 'react';
import EventServices from './components/EventServices';
import ImageCarousel from './components/ImageCarousel';
import ContactForm from './components/ContactForm';
import WhatsAppContact from './components/WhatsAppContact';

function App() {
  return (
    <div className="App">

      <EventServices />
      <ImageCarousel />
      <ContactForm />
      <WhatsAppContact />
    </div>
  );
}

export default App;

